import { Navigate, useLocation } from 'react-router-dom';
import storage from '../assets/js/Global';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const loginObj = storage.get('user');

    const isAuthenticated = loginObj && loginObj.user_pid;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;